import { render, staticRenderFns } from "./AdminDropdown.vue?vue&type=template&id=b827022c"
import script from "./AdminDropdown.vue?vue&type=script&lang=js"
export * from "./AdminDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports